export default "__VITE_ASSET__01e54283__"